// components/Bit.js
import React from 'react';
import './Bit.css';
import CodeBlock from './CodeBlock';

const BitLogo = () => (
  <div className="logo-container">
    <div className="bit-offset">
      <div className="offset-back"></div>
      <div className="offset-front"></div>
    </div>
    <span className="logo-text">Bit</span>
  </div>
);

const Bit = () => {
  const bitExampleCode = `from cinder import ModelDebugger
import torch

CINDER_API_KEY = "your-api-key-here"

# Initialize model debugger
debugger = ModelDebugger(
    model=model,            # Your PyTorch model
    dataset=test_loader,    # Test dataset
    api_key=CINDER_API_KEY
)

# Run analysis to get insights
results = debugger.analyze()

# Launch dashboard with Bit assistant
debugger.launch_dashboard(port=8000)

# In the dashboard, you can:
# - Chat with Bit about model improvements
# - Get automatic code optimizations
# - Analyze error patterns
# - Generate implementation code

# You can also access some features programmatically:
suggestions = debugger.get_improvement_suggestions()
print(f"Bit suggests: {suggestions[0]['title']}")`;

  return (
    <section className="bit" id="bit">
      <div className="section-header">
        <div className="dev-pill">In Development</div>
        <h2>Bit: AI Assistant</h2>
        <p>Web-based AI assistant for model improvement and code generation</p>
      </div>
      
      <div className="bit-container">
        <div className="bit-info">
          <div className="bit-header">
            <BitLogo />
            <h3>by Cinder</h3>
          </div>
          
          <p className="bit-description">
            Bit is an AI-powered assistant available through Cinder's dashboard that analyzes
            your machine learning models and provides optimization suggestions, error analysis,
            and generates implementation code through a chat interface.
          </p>
          
          <ul className="bit-features">
            <li>Interactive chat interface accessible through the dashboard</li>
            <li>Code generation for fixing model issues</li>
            <li>Automatic optimization with explanations</li>
            <li>Integration with Cinder's analysis engine</li>
            <li>Works best with PyTorch models</li>
          </ul>
        </div>
        
        <div className="bit-code">
          <CodeBlock 
            code={bitExampleCode}
            language="python"
            showLineNumbers={false}
          />
        </div>
      </div>
      
      <div className="bit-note">
        <p><strong>Note:</strong> Bit is currently available as a web-based interface through the Cinder dashboard.
        The most extensive functionality is available for PyTorch models, with growing support for other frameworks.</p>
      </div>
    </section>
  );
};

export default Bit;